import { PricingGrid } from "../../constants/Pricing";
import {
  FETCH_PRICING_PLANS,
  CHANGE_PRICING_PLAN,
  SELECT_PRICING_PLAN,
} from "../actionTypeConstants/constants";

const initialState = {
  interval: "year",
  loader: true,
  items: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRICING_PLANS: {
      let { interval } = state;
      if (PricingGrid.data && PricingGrid.data.length) {
        PricingGrid.data.forEach(function (el) {
          if (el.products && el.products.length !== 0) {
            el.products.forEach(function (product) {
              if (product.plans && product.plans.length) {
                product.plans.forEach(function (plan) {
                  if (plan && plan.interval === "month") {
                    product.month = plan;
                  } else if (plan && plan.interval === "year") {
                    product.year = plan;
                  }
                });
              }
            });
          }
        });
      }

      return {
        ...state,
        items: PricingGrid.data,
        loader: false,
        row: PricingGrid.data[1].products[0].name,
        row2: PricingGrid.data[2].products[0].name,
        row3: PricingGrid.data[3].products[0].name,
        display_price: PricingGrid.data[1].products[0][interval].display_price,
        display_price2: PricingGrid.data[2].products[0][interval].display_price,
        display_price3: PricingGrid.data[3].products[0][interval].display_price,
        display_code: PricingGrid.data[1].products[0][interval].code,
        display_code2: PricingGrid.data[2].products[0][interval].code,
        display_code3: PricingGrid.data[3].products[0][interval].code,
      };
    }
    case CHANGE_PRICING_PLAN: {

      return {
        ...state,
        interval: action.durationType,
        items: PricingGrid.data,
        row: PricingGrid.data[1].products[0].name,
        row2: PricingGrid.data[2].products[0].name,
        row3: PricingGrid.data[3].products[0].name,
        display_price: PricingGrid.data[1].products[0][action.durationType].display_price,
        display_price2: PricingGrid.data[2].products[0][action.durationType].display_price,
        display_price3: PricingGrid.data[3].products[0][action.durationType].display_price,
        display_code: PricingGrid.data[1].products[0][action.durationType].code,
        display_code2: PricingGrid.data[2].products[0][action.durationType].code,
      };
    }
    case SELECT_PRICING_PLAN: {
        const {interval} = state
        const {item, index, mainindex} = action
        if (mainindex == 1) {
            return {
                ...state,
                row: PricingGrid.data[mainindex].products[index].name,
                display_price: item[interval].display_price,
                display_code: item[interval].code
            }
          } else if(mainindex == 2){
            return {
                ...state,
                row2: PricingGrid.data[mainindex].products[index].name,
                display_price2: item[interval].display_price,
                display_code2: item[interval].code
            }
          }else{
            return {
                ...state,
                row3: PricingGrid.data[mainindex].products[index].name,
                display_price3: item[interval].display_price,
                display_code3: item[interval].code
            }
          }
      }
    default:
      return state;
  }
};
